import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  selectContextCore,
  selectContextDeviceType,
  selectIsLanding,
} from '@store/context/context.selector';
import { IContextDevice } from '@store/context/context.state';
import { IHotelsAppState } from '@store/index';
import { selectQuery } from '@store/router/router.selector';
import { take } from 'rxjs/operators';
import { SearchService } from './search.service';

@Injectable()
export class UrlService {
  public mapping: any;
  public isExpertsContext: boolean;

  constructor(private store$: Store<IHotelsAppState>, private searchService: SearchService) {
    this.store$
      .pipe(select(selectContextCore))
      .pipe(take(1))
      .subscribe((context) => {
        this.isExpertsContext =
          context.channel.toUpperCase() === 'CCR' || context.channel.toUpperCase() === 'RETAIL';
      });
    this.initialSetup();
  }

  public initialSetup() {
    const from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç´';
    const to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuuNnCc-';
    this.mapping = {};
    for (let i = 0, j = from.length; i < j; i++) {
      this.mapping[from.charAt(i)] = to.charAt(i);
    }
  }

  public getResizedUrl() {
    let url = '';
    const SIZES = {
      desktop: 419,
      mobile: 400,
      tablet: 752,
    };
    const env = location.host.split('.')[0];
    let subdomain = '';
    if (env === 'dev' || env === 'st') {
      subdomain = 'st.';
    } else if (env === 'ccr' || env === 'sucursales') {
      subdomain = '';
    }
    this.store$
      .pipe(select(selectContextDeviceType))
      .subscribe((deviceType: IContextDevice['type']) => {
        url = `https://${subdomain}images.almundo.com/205/image/fetch/fl_progressive,q_auto,c_fill,g_auto,w_${SIZES[deviceType]}/`;
      })
      .unsubscribe();
    return url;
  }

  private getDetailUrl(hotel, query, isLanding) {
    const params = query.queryParams;
    const entity = query.entity;
    let slugName = hotel.slug.split('-');
    let slugId = slugName.pop();
    slugName = slugName.join('-');
    slugId = this.searchService.getHashedId(slugId);
    let finalUrl = `${window.location.origin}/hotels/detail/${slugName}-${slugId}`;
    if (!isLanding) {
      finalUrl += `?date=${params.date}&rooms=${params.rooms}`;
      if (params.priceBy) {
        finalUrl += `&priceBy=${params.priceBy}`;
      }
      if (params.flexible) {
        finalUrl += `&flexible=${params.flexible}`;
      }
      if (params.PAYMENT_METHOD) {
        finalUrl += `&PAYMENT_METHOD=${params.PAYMENT_METHOD}`;
      }
      if (hotel.rate) {
        finalUrl += `&p=${hotel.rate.price.stringified_price}`;
      }

      if (params.withFullPrice) {
        finalUrl += `&withFullPrice=${params.withFullPrice}`;
      }
      if (params.brand) {
        finalUrl += `&brand=${params.brand}`;
      }
      if (params.currencyCode) {
        finalUrl += `&currencyCode=${params.currencyCode}`;
      }

      finalUrl += `&origin=${entity.id}`;
    }
    return finalUrl;
  }

  public getDetailRedirection(hotel) {
    const redirection = { url: '', self: false };
    let landing: boolean;
    this.store$
      .pipe(select(selectIsLanding))
      .subscribe((isLanding) => {
        landing = isLanding;
      })
      .unsubscribe();
    this.store$
      .pipe(select(selectQuery))
      .subscribe((query) => {
        redirection.url = this.getDetailUrl(hotel, query, landing);
        redirection.self = query.queryParams.selfRedirect === 'true';
      })
      .unsubscribe();
    return redirection;
  }

  public normalizeUrl(str: string) {
    const ret = [];
    for (let i = 0, j = str.length; i < j; i++) {
      const c = str.charAt(i);
      if (this.mapping.hasOwnProperty(c)) {
        ret.push(this.mapping[c]);
      } else {
        ret.push(c);
      }
    }
    const result = ret.join('').toLowerCase().split(' ').join('-');
    return result;
  }

  public isExperts(): boolean {
    return this.isExpertsContext;
  }

  public redirectCurrency(currency: string) {
    let finalUrl = '';
    this.store$
      .pipe(select(selectQuery))
      .subscribe((query) => {
        const nameOrigin = query.entity.name.replaceAll(' ', '-');
        finalUrl = `${window.location.origin}/hotels/results/${nameOrigin}-${query.entity.id}`;
        const changeParams = {
          ...query.queryParams,
          currencyCode: currency.toUpperCase(),
        };
        const paramsUrl = new URLSearchParams(changeParams).toString();
        finalUrl += `?${paramsUrl}`;
      })
      .unsubscribe();
    window.location.href = finalUrl;
  }
}
